var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"annula-index-main-container"},_vm._l((_vm.annualList),function(year,index){return _c('div',{key:index,class:{'annual-lable': true, highlight: year.annualLabel === _vm.$route.params.year},on:{"click":function($event){return _vm.changeAnnualIndex(year)}}},[_vm._v(" "+_vm._s(year.annualLabel)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }